// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One button vocabulary across every catalog surface.
 *
 * Black is an action (Add to dataflow, Publish...), white with a border is
 * destructive (Remove from dataflow, Delete, Unpublish). Publish sat outside
 * that vocabulary entirely: a small blue pill, in its own size, in its own
 * colour, which read as a status chip saying the thing was already published
 * rather than as a button that would publish it.
 *
 * The \`hub\` variant below therefore takes \`.btnInstall\`'s colours and
 * \`.btnSecondary\`'s box (PackageCard.module.css), so it stacks with the other
 * card actions instead of floating beside them. \`dock\` is the dark left-rail
 * panel, where a black fill would vanish into the background, so it keeps a
 * light treatment.
 *
 * The "Published" BADGE is a state, not an action, and stays deliberately
 * quiet in both variants. */

/* Dock palette (dark panel) */
.XDImtvEAI1LipOKllxtB {
    flex-shrink: 0;
    font-family: var(--curio-font-family);
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: var(--curio-role-published-bg);
    background: transparent;
    border: 1px solid rgba(53, 103, 199, 0.6);
    border-radius: var(--curio-radius-pill);
    padding: 3px 9px;
    cursor: pointer;
    line-height: 1.15;
}

.XDImtvEAI1LipOKllxtB:hover:not(:disabled) {
    background: rgba(53, 103, 199, 0.28);
    border-color: var(--curio-role-published-fg);
}

.XDImtvEAI1LipOKllxtB:disabled {
    opacity: 0.42;
    cursor: not-allowed;
}

/* Nodes hub rail (light) */
.auMlpI7IooVU8aaPxtQy {
    flex-shrink: 0;
    min-width: 96px;
    height: 30px;
    padding: 0 12px;
    font-family: var(--curio-font-family);
    font-size: var(--curio-font-size-sm);
    font-weight: 600;
    color: var(--curio-text-on-dark);
    background: var(--curio-top-bar-bg);
    border: 1px solid var(--curio-top-bar-bg);
    border-radius: var(--curio-radius-md);
    cursor: pointer;
    line-height: 1.15;
}

.auMlpI7IooVU8aaPxtQy:hover:not(:disabled) {
    background: var(--curio-top-bar-bg-hover);
    border-color: var(--curio-top-bar-bg-hover);
}

.auMlpI7IooVU8aaPxtQy:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

/* The DRAWER box. A browse drawer stacks the publish control directly under
 * "Add to all projects" (\`.addToPaletteBtn\`, 100% x 42px), and the pill's card
 * geometry (96px x 30px) put a stubby little button under a full-width one.
 * These two rules deliberately duplicate \`.addToPaletteBtn\` / \`.destructiveBtn\`
 * from CatalogBrowseLayout.module.css: CSS modules hash per file, so the class
 * cannot be shared across the module boundary, and the drawer's own stylesheet
 * is not reachable from here. Keep the three in step. */
.MgHEFS77EK2NpP09aN2L {
    width: 100%;
    height: 42px;
    padding: 0 12px;
    border: 1px solid var(--curio-top-bar-bg);
    border-radius: 8px;
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    font-family: inherit;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.MgHEFS77EK2NpP09aN2L:hover:not(:disabled) {
    background: var(--curio-top-bar-bg-hover);
    border-color: var(--curio-top-bar-bg-hover);
}

.MgHEFS77EK2NpP09aN2L:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

/* The destructive twin, same box, matching \`.destructiveBtn\`. */
.fuzFXvrzjmee3PulKyDw {
    width: 100%;
    height: 42px;
    padding: 0 12px;
    border: 1px solid var(--curio-border-strong);
    border-radius: 8px;
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font-family: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.fuzFXvrzjmee3PulKyDw:hover:not(:disabled) {
    background: var(--curio-surface-muted);
}

.fuzFXvrzjmee3PulKyDw:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

/* Unpublish is destructive, so it takes the light treatment. It shares the
 * action's box exactly, because it occupies the same slot: a card swapping
 * Publish for Unpublish must not change shape. */
.b0LmutWh29IrgkMN4P8l {
    flex-shrink: 0;
    min-width: 96px;
    height: 30px;
    padding: 0 12px;
    font-family: var(--curio-font-family);
    font-size: var(--curio-font-size-sm);
    font-weight: 500;
    color: var(--curio-text-primary);
    background: var(--curio-card-bg);
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    cursor: pointer;
    line-height: 1.15;
}

.b0LmutWh29IrgkMN4P8l:hover:not(:disabled) {
    border-color: #888787;
    background: var(--curio-page-bg);
}

.b0LmutWh29IrgkMN4P8l:disabled,
.B9nl8qjOTxVJiySu3PJ5:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* The dark rail keeps a light-on-dark treatment; a white fill would be as loud
 * there as a black one is on a card. */
.B9nl8qjOTxVJiySu3PJ5 {
    flex-shrink: 0;
    font-family: var(--curio-font-family);
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: rgba(255, 255, 255, 0.72);
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: var(--curio-radius-pill);
    padding: 3px 9px;
    cursor: pointer;
    line-height: 1.15;
}

.B9nl8qjOTxVJiySu3PJ5:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.45);
}

`, "",{"version":3,"sources":["webpack://./src/components/packages/CatalogPublishPill.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;4BAe4B;;AAE5B,8BAA8B;AAC9B;IACI,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qCAAqC;IACrC,uBAAuB;IACvB,yCAAyC;IACzC,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,oCAAoC;IACpC,gBAAgB;IAChB,gCAAgC;IAChC,mCAAmC;IACnC,yCAAyC;IACzC,qCAAqC;IACrC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;;;wDAMwD;AACxD;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yCAAyC;IACzC,kBAAkB;IAClB,mCAAmC;IACnC,gCAAgC;IAChC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,yCAAyC;IACzC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,gEAAgE;AAChE;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,4CAA4C;IAC5C,kBAAkB;IAClB,gCAAgC;IAChC,gCAAgC;IAChC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;iDAEiD;AACjD;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,oCAAoC;IACpC,gBAAgB;IAChB,gCAAgC;IAChC,gCAAgC;IAChC,4CAA4C;IAC5C,qCAAqC;IACrC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;uCACuC;AACvC;IACI,cAAc;IACd,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;IAChC,uBAAuB;IACvB,2CAA2C;IAC3C,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C","sourcesContent":["/* One button vocabulary across every catalog surface.\n *\n * Black is an action (Add to dataflow, Publish...), white with a border is\n * destructive (Remove from dataflow, Delete, Unpublish). Publish sat outside\n * that vocabulary entirely: a small blue pill, in its own size, in its own\n * colour, which read as a status chip saying the thing was already published\n * rather than as a button that would publish it.\n *\n * The `hub` variant below therefore takes `.btnInstall`'s colours and\n * `.btnSecondary`'s box (PackageCard.module.css), so it stacks with the other\n * card actions instead of floating beside them. `dock` is the dark left-rail\n * panel, where a black fill would vanish into the background, so it keeps a\n * light treatment.\n *\n * The \"Published\" BADGE is a state, not an action, and stays deliberately\n * quiet in both variants. */\n\n/* Dock palette (dark panel) */\n.pillDock {\n    flex-shrink: 0;\n    font-family: var(--curio-font-family);\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: var(--curio-role-published-bg);\n    background: transparent;\n    border: 1px solid rgba(53, 103, 199, 0.6);\n    border-radius: var(--curio-radius-pill);\n    padding: 3px 9px;\n    cursor: pointer;\n    line-height: 1.15;\n}\n\n.pillDock:hover:not(:disabled) {\n    background: rgba(53, 103, 199, 0.28);\n    border-color: var(--curio-role-published-fg);\n}\n\n.pillDock:disabled {\n    opacity: 0.42;\n    cursor: not-allowed;\n}\n\n/* Nodes hub rail (light) */\n.pillHub {\n    flex-shrink: 0;\n    min-width: 96px;\n    height: 30px;\n    padding: 0 12px;\n    font-family: var(--curio-font-family);\n    font-size: var(--curio-font-size-sm);\n    font-weight: 600;\n    color: var(--curio-text-on-dark);\n    background: var(--curio-top-bar-bg);\n    border: 1px solid var(--curio-top-bar-bg);\n    border-radius: var(--curio-radius-md);\n    cursor: pointer;\n    line-height: 1.15;\n}\n\n.pillHub:hover:not(:disabled) {\n    background: var(--curio-top-bar-bg-hover);\n    border-color: var(--curio-top-bar-bg-hover);\n}\n\n.pillHub:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n/* The DRAWER box. A browse drawer stacks the publish control directly under\n * \"Add to all projects\" (`.addToPaletteBtn`, 100% x 42px), and the pill's card\n * geometry (96px x 30px) put a stubby little button under a full-width one.\n * These two rules deliberately duplicate `.addToPaletteBtn` / `.destructiveBtn`\n * from CatalogBrowseLayout.module.css: CSS modules hash per file, so the class\n * cannot be shared across the module boundary, and the drawer's own stylesheet\n * is not reachable from here. Keep the three in step. */\n.pillDrawer {\n    width: 100%;\n    height: 42px;\n    padding: 0 12px;\n    border: 1px solid var(--curio-top-bar-bg);\n    border-radius: 8px;\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    font-family: inherit;\n    font-size: 13px;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.pillDrawer:hover:not(:disabled) {\n    background: var(--curio-top-bar-bg-hover);\n    border-color: var(--curio-top-bar-bg-hover);\n}\n\n.pillDrawer:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n/* The destructive twin, same box, matching `.destructiveBtn`. */\n.undoDrawer {\n    width: 100%;\n    height: 42px;\n    padding: 0 12px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: 8px;\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font-family: inherit;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.undoDrawer:hover:not(:disabled) {\n    background: var(--curio-surface-muted);\n}\n\n.undoDrawer:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n/* Unpublish is destructive, so it takes the light treatment. It shares the\n * action's box exactly, because it occupies the same slot: a card swapping\n * Publish for Unpublish must not change shape. */\n.undoHub {\n    flex-shrink: 0;\n    min-width: 96px;\n    height: 30px;\n    padding: 0 12px;\n    font-family: var(--curio-font-family);\n    font-size: var(--curio-font-size-sm);\n    font-weight: 500;\n    color: var(--curio-text-primary);\n    background: var(--curio-card-bg);\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    cursor: pointer;\n    line-height: 1.15;\n}\n\n.undoHub:hover:not(:disabled) {\n    border-color: #888787;\n    background: var(--curio-page-bg);\n}\n\n.undoHub:disabled,\n.undoDock:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n/* The dark rail keeps a light-on-dark treatment; a white fill would be as loud\n * there as a black one is on a card. */\n.undoDock {\n    flex-shrink: 0;\n    font-family: var(--curio-font-family);\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: rgba(255, 255, 255, 0.72);\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.28);\n    border-radius: var(--curio-radius-pill);\n    padding: 3px 9px;\n    cursor: pointer;\n    line-height: 1.15;\n}\n\n.undoDock:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.08);\n    border-color: rgba(255, 255, 255, 0.45);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pillDock": `XDImtvEAI1LipOKllxtB`,
	"pillHub": `auMlpI7IooVU8aaPxtQy`,
	"pillDrawer": `MgHEFS77EK2NpP09aN2L`,
	"undoDrawer": `fuzFXvrzjmee3PulKyDw`,
	"undoHub": `b0LmutWh29IrgkMN4P8l`,
	"undoDock": `B9nl8qjOTxVJiySu3PJ5`
};
export default ___CSS_LOADER_EXPORT___;
